import { Country } from '~/Api/Country';

export enum ErrorCode {
	IllegalPriceTypeSelectedErrorCode = 'slovak-max-price-calculation-illegal-price-type-selected',
	OnlyOneProductPerCountryErrorCode = 'slovak-max-price-calculation-requires-at-most-one-product-for-each-country',
	RequiredProductSettingsMissingErrorCode = 'slovak-max-price-calculation-required-product-settings-is-missing',
	RequiresReferenceSettings = 'slovak-max-price-calculation-requires-reference-settings',
	AtLeastOneReferenceCountryProduct = 'slovak-max-price-calculation-requires-at-least-one-reference-country-product',
}

export class Error {
	public constructor(
		public readonly code: ErrorCode,
		public readonly productId: string | null,
		public readonly productGroupId: string | null,
		public readonly duplicateCountries: Country[]
	) {}
}
